import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ETPOS/CommonStyles.css';
import AddSell from './ETPOS/AddSell';
import AddDraft from './ETPOS/AddDraft';
import AddQuotation from './ETPOS/AddQuotation';
import AllSell from './ETPOS/AllSell';

const Sell = () => {
  const [activeTab, setActiveTab] = useState('view');
  const [activeViewTab, setActiveViewTab] = useState('all_sales');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Update active tab based on URL
  useEffect(() => {
    if (location.pathname === '/sell/add') {
      setActiveTab('add');
    } else if (location.pathname === '/sell/add-draft') {
      setActiveTab('add_draft');
    } else if (location.pathname === '/sell/add-quotation') {
      setActiveTab('add_quotation');
    } else if (location.pathname === '/sell/quotations') {
      setActiveTab('view');
      setActiveViewTab('list_quotation');
    } else if (location.pathname === '/sell/drafts') {
      setActiveTab('view');
      setActiveViewTab('list_draft');
    } else {
      setActiveTab('view');
      setActiveViewTab('all_sales');
    }
  }, [location.pathname]);

  // Render content based on active tab
  const renderContent = () => {
    if (activeTab === 'add') {
      return <AddSell />;
    } else if (activeTab === 'add_draft') {
      return <AddDraft />;
    } else if (activeTab === 'add_quotation') {
      return <AddQuotation />;
    } else {
      return <AllSell searchTerm={searchTerm} initialTab={activeViewTab} />;
    }
  };

  return (
    <div className="module-container">
      <div className="module-content1">
        {renderContent()}
      </div>
    </div>
  );
};

export default Sell;
